import React from "react";
const MauThuChiTableRows = ({ list, pageIndex, pageSize, onShowDetail, onEdit }) => {
  // console.log("list: ", list);
  if (!list || list.length === 0) {
    return (
      <div className="custom-table-row">
        <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return list.map((item, index) => (
    // console.log("item: ", item) ||
    <div className="custom-table-row" key={"item" + index}>
      <div className="custom-table-cell" style={{ width: "5%" }}>
        <span className="mobile-column-name color7-bold">STT</span>
        <div className="center-wrapper" >
          <p className="text-center color7">{(pageIndex - 1) * pageSize + index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell" style={{ width: "85%" }}>
        <span className="mobile-column-name color7-bold text-center">Tên phiểu thu/ chi</span>
        <div className="center-wrapper text-center">
          <a
            className="profile_name word-break red"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              margin: 0,
              cursor: "pointer",
              color: "#007bff",
              textDecoration: "underline"
            }}
            onClick={() => onShowDetail(item)}
          >
            {item.ContractName}
          </a>
        </div>
      </div>
      <div className="custom-table-cell" style={{ width: "10%" }}>
        <span className="mobile-column-name color7-bold">Thao tác</span>
        <div className="" >
          <a
            style={{ marginTop: "7px", marginLeft: "7px", marginBottom: "7px", fontSize: "12px", height: "fit-content" }}
            className="iconTableMorman"
            onClick={() => onEdit(item)}
            title="Sửa"
          >
            <img src="/app-assets/images/icon-edit-v2.png"></img>
          </a>
        </div>
      </div>
    </div>
  ));
};
const MauThuChiTable = ({ list, pageIndex, pageSize, onShowDetail, iTotal,onEdit  }) => (
  <div className="Left808x200 Table-main-new css-table-ds">
    <div className="table-mobile table-mobile-hover">
      <div className="custom-table-wrapper">
        <div className="table-headers" >
          <div className="custom-table-header text-center " style={{ width: "5%" }}>
            <p className="color-do-bold">
              STT
              <br />[{iTotal === 0 ? 0 : iTotal}]
            </p>
          </div>
          <div className="custom-table-header text-center" style={{ width: "85%" }}>
            <p>Tên phiếu thu/chi</p>
          </div>
          <div className="custom-table-header" style={{ width: "10%" }}>
            <p>Thao tác</p>
          </div>
        </div>
        <div className="custom-table-body">
          <MauThuChiTableRows
            list={list}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onShowDetail={onShowDetail}
            onEdit={onEdit}
          />
        </div>
      </div>
    </div>
  </div>
);

export default MauThuChiTable;